/** 앱·웹 공통으로 보여줄 인증서 만료 안내 */
export const CERT_EXPIRED_CRAWL_MESSAGE =
  '인증서가 만료되어 자동가져오기를 할 수 없습니다. 새 인증서를 등록한 뒤 다시 시도해 주세요.'

type CrawlQueueItem = {
  cmq_idx?: number
  cmq_status?: string
  cmq_error_type?: string | null
  cmq_error_message?: string | null
}

export function isCertExpiredCrawlError(item: CrawlQueueItem | null | undefined): boolean {
  if (!item) return false
  if (item.cmq_error_type === 'CERT_EXPIRED') return true
  const msg = String(item.cmq_error_message || '')
  return /인증서/.test(msg) && /만료/.test(msg)
}

/** 진행 중이던 요청이 인증서 만료로 실패한 경우만 */
export function hasNewCertExpiredFailure(prev: CrawlQueueItem[], next: CrawlQueueItem[]): boolean {
  if (!prev.length) return false
  const prevStatus = new Map(prev.map((item) => [item.cmq_idx, item.cmq_status]))
  return next.some((item) => {
    const before = prevStatus.get(item.cmq_idx)
    if (before !== 'pending' && before !== 'processing') return false
    return item.cmq_status === 'failed' && isCertExpiredCrawlError(item)
  })
}
